import { render, staticRenderFns } from "./disinfect.vue?vue&type=template&id=5e5007ef&scoped=true&"
import script from "./disinfect.vue?vue&type=script&lang=js&"
export * from "./disinfect.vue?vue&type=script&lang=js&"
import style0 from "./disinfect.vue?vue&type=style&index=0&id=5e5007ef&prod&lang=less&"
import style1 from "./disinfect.vue?vue&type=style&index=1&id=5e5007ef&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e5007ef",
  null
  
)

export default component.exports